import { Box, useBreakpointValue } from "@chakra-ui/react"
import styled from "styled-components"
import { Category } from "../../../../api-clients/product-api-v1"
import breakpoints from "../../../../theme/chakra/foundation/breakpoints"
import GeberitCarousel from "../../../shared/Geberit/GeberitCarousel"
import SeriesTile from "./SeriesTile"

type Props = {
  seriesCategories: Category[]
}

// Additional styling for the Geberit carousel component to fit OCNext tiles carousels designs
const CarouselWrapper = styled(Box)`
  .carousel-container {
    gap: 12px;
  }

  .swiper-slide {
    min-width: 808px;
    max-width: 808px;
  }

  @media (min-width: ${breakpoints.sm}) and (max-width: 1023px) {
    .swiper-slide {
      min-width: 720px;
      max-width: 720px;
    }
  }

  @media (min-width: ${breakpoints.xs}) and (max-width: 767px) {
    .swiper-slide {
      min-width: 492px;
      max-width: 492px;
    }
  }

  @media (min-width: 0px) and (max-width: ${breakpoints.xs}) {
    .swiper-slide {
      min-width: 288px;
      max-width: 100vw;
    }
  }
`

export const CarouselSeries = ({ seriesCategories }: Props) => {
  // We have different tile sizes by breakpoint, that's why we need to pass different slide size to the carousel
  const slidesWidth = useBreakpointValue({ base: "100vw", xs: 492, sm: 720, md: 804 })

  const slidesSmall = useBreakpointValue({ base: 1, xs: 1.5, md: 1.5 })
  const slidesMedium = useBreakpointValue({ base: 1, sm: 1.5, md: 1.5 })

  const responsiveLayout = {
    small: { slides: slidesSmall, slidesToMove: 1 },
    medium: { slides: slidesMedium, slidesToMove: 1 },
    large: { slides: 1.5, slidesToMove: 1 },
  }

  return (
    <CarouselWrapper>
      <GeberitCarousel
        responsiveLayout={responsiveLayout}
        hideIndicator={seriesCategories?.length === 1}
        slideMargin={24}
        slidesWidth={[slidesWidth]}
        key={slidesWidth}
      >
        {seriesCategories.map((sc, index) => (
          <SeriesTile series={sc} isOdd={(index + 1) % 2 === 1} key={sc.id} />
        ))}
      </GeberitCarousel>
    </CarouselWrapper>
  )
}
